import { api_handler } from "./api";

export const isBrowser = () => typeof window !== "undefined";

let AuthToken = "";

export const getUserIdentifier = () => {
  const tellToken = getTellToken();
  const jwt = extractJWT(tellToken);

  if (tellToken === "") {
    return false;
  } else {
    return jwt.sub;
  }
};

export const clearLocalStorage = (user) => {
  window.localStorage.clear();
};


export const setUserData = (user) => {
  window.localStorage.setItem("user_info", JSON.stringify(user));
};

export const getUserData = () => {
  if (isBrowser() && window.localStorage.getItem("user_info")) {
    const userData = JSON.parse(window.localStorage.getItem("user_info"));
    return userData;
  } else {
  }
  return {};
};

export const getQRCode = () => {
  if (isBrowser() && window.localStorage.getItem("stageOneData")) {
    const s1Data = JSON.parse(window.localStorage.getItem("stageOneData"));
    return s1Data.mfa_url;
  } else {
  }
};

export const getQRSecret = () => {
  if (isBrowser() && window.localStorage.getItem("stageOneData")) {
    const s1Data = JSON.parse(window.localStorage.getItem("stageOneData"));
    return s1Data.mfa_secret;
  } else {
  }
};

export const extractJWT = (str) => {
  let decodedJWT = "";
  if (isBrowser()) {
    if (str === "" || str.trim() === "") {
      return {};
    }

    try {
      var res = str.split(".");
      decodedJWT = JSON.parse(atob(res[1]));
    } catch (err) {
      console.log(err);
      return {};
    }

    return decodedJWT;
  } else {
    return {};
  }
};

export const getTellAuthJWT = () => {
  if (isBrowser() && window.localStorage.getItem("stageOneData")) {
    const s1Data = JSON.parse(window.localStorage.getItem("stageOneData"));
    return s1Data.jwt;
  } else {
  }
};

export const getTellToken = () => {
  if (isBrowser() && window.localStorage.getItem("access-token")) {
    const token = window.localStorage.getItem("access-token");
    return token;
  } else {
    return "";
  }
};

const setAuthToken = (token) => {
  AuthToken = token;
};

export const setAuthTokenRemote = (authToken) => {
  setAuthToken(authToken);
};

const getAuthToken = () => {
  if (isBrowser()) {
    return AuthToken;
  } else {
    return "";
  }
};

const setStageOneData = (data) =>
  window.localStorage.setItem("stageOneData", JSON.stringify(data));

export const handleLoginStageOne = async (email, password) => {
  var data = {
    username: email,
    password: password,
  };

  var rsp_obj = {};

  const api_rsp = await api_handler("login_init", data, "POST");

  switch (api_rsp.code) {
    case 201:
      // MFA SET_UP REQUIRED
      setAuthToken(api_rsp.data.auth_token);
      rsp_obj.op_code = 200;
      rsp_obj.qr_code = api_rsp.data.qr_code;
      rsp_obj.qr_secret = api_rsp.data.mfa_code;
      setStageOneData(rsp_obj);
      break;
    case 200:
      // MFA SET_UP COMPLETE
      setAuthToken(api_rsp.data.auth_token);
      rsp_obj.op_code = 201;
      setStageOneData(rsp_obj);
      break;
    case 401:
      // MFA SET_UP COMPLETE
      switch (api_rsp.subcode) {
        case "401-001":
          rsp_obj.op_code = 401;
          setStageOneData(rsp_obj);
          break;
        case "401-002":
          rsp_obj.op_code = 402;
          setStageOneData(rsp_obj);
          break;
        default:
          rsp_obj.op_code = 500;
          setStageOneData(rsp_obj);
      }

      break;
    default:
      rsp_obj.op_code = 500;
      setStageOneData(rsp_obj);
  }

  return rsp_obj;
};

export const handleLoginStageTwo = async (otp) => {
  var data = {
    auth_token: getAuthToken(),
    otp: otp,
  };

  var rsp_obj = {};

  const api_rsp = await api_handler("login_mfa", data, "POST");

  switch (api_rsp.code) {
    case 200:
      rsp_obj.op_code = 200;
      rsp_obj.default_console_home = api_rsp.data.default_secure_home;
      setUserData(api_rsp.data);
      break;
    case 500:
      rsp_obj.op_code = 401;
      break;
    default:
      rsp_obj.op_code = 500;
  }

  return rsp_obj;
};

export const handleLoginAggregate = async () => {
  var data = {
    user_id: getUserIdentifier(),
  };

  var rsp_obj = {};

  const api_rsp = await api_handler("user:view", data, "POST");

  switch (api_rsp.code) {
    case 200:
      setUserData(api_rsp.data);
      rsp_obj.op_code = 200;
      break;
    case 500:
      rsp_obj.op_code = 401;
      break;
    default:
      rsp_obj.op_code = 500;
  }

  return rsp_obj;
};

export const isLoggedIn = () => { 
  const tellToken = getTellToken();
  if (tellToken === "") {
    return false;
  }

  const now = new Date();
  const jwt = extractJWT(tellToken);
  if (jwt.exp === undefined) {
    return false;
  } else {
    if (now.getTime() > jwt.exp * 1000) {
      return false;
    }
  }

  return true;
};

export const isAuthorised = (scope = "*") => {
  const tellToken = getTellToken();
  const jwt = extractJWT(tellToken);

  if (tellToken === "") {
    return false;
  } else {
    const now = new Date();

    if (jwt.exp === undefined) {
      return false;
    } else {
      if (now.getTime() > jwt.exp * 1000) {
        return false;
      }
    }
  }
  let scope_test = false;
  switch (scope) {
    case "*":
      if (jwt.scopes.length > 0) {
        scope_test = true;
      } else {
        scope_test = false;
      }
      break;
    default:
      // A scope has been specified so ensure that its held within a valid jwt
      const grantedScopes = jwt.scopes;
      const scope_found = grantedScopes.indexOf(scope);

      if (scope_found < 0) {
        scope_test = false;
      } else {
        scope_test = true;
      }

      break;
  }
  return scope_test;
};

export const logout = async () => {
  var data = {};
  await  api_handler("logout", data, "POST");

};
